import { useMemo } from 'react';
import type { TextContent } from '@mawkaa/types';
import { cn } from '@mawkaa/ui';
import { sanitizeHtmlWithSecureLinks } from '@/lib/sanitize';

interface TextBlockProps {
  content: TextContent;
  isEditing?: boolean;
}

export function TextBlock({ content, isEditing }: TextBlockProps) {
  const { content: htmlContent, alignment = 'left' } = content;

  // Sanitize HTML content to prevent XSS attacks
  const sanitizedContent = useMemo(() => {
    if (!htmlContent) return '';
    return sanitizeHtmlWithSecureLinks(htmlContent);
  }, [htmlContent]);

  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  return (
    <section className="px-4 py-12">
      <div className={cn('max-w-4xl mx-auto prose prose-lg', alignmentClasses[alignment])}>
        {sanitizedContent ? (
          <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
        ) : isEditing ? (
          <p className="text-muted-foreground italic">Cliquez pour ajouter du texte...</p>
        ) : null}
      </div>
    </section>
  );
}
